"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSeekbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _range = _interopRequireDefault(require("lodash/range"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _value2 = require("../../skybase-core/utils/value");

var _sbHint = require("../sb-hint");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbSeekbar = /*#__PURE__*/function (_Component) {
  _inherits(SbSeekbar, _Component);

  var _super = _createSuper(SbSeekbar);

  function SbSeekbar(props) {
    var _this;

    _classCallCheck(this, SbSeekbar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      var _event$target, _event$target$classLi, _event$target$classLi2, _event$target2, _event$target2$classL, _event$target2$classL2;

      event.preventDefault();
      var _this$state = _this.state,
          precision = _this$state.precision,
          value = _this$state.value,
          min = _this$state.min,
          max = _this$state.max,
          step = _this$state.step;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          range = _this$props.range,
          showTooltips = _this$props.showTooltips;
      var isHandle = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$classLi = _event$target.classList) === null || _event$target$classLi === void 0 ? void 0 : (_event$target$classLi2 = _event$target$classLi.contains) === null || _event$target$classLi2 === void 0 ? void 0 : _event$target$classLi2.call(_event$target$classLi, 'handle');

      if (disabled || range && !isHandle) {
        return;
      }

      var offsetX = isHandle ? event.target.offsetLeft : event.offsetX;
      var startX = event.clientX;
      var absWidth = event.currentTarget.offsetWidth;
      var startSliderPosition = offsetX / absWidth;
      var handleIndex = ((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : (_event$target2$classL = _event$target2.classList) === null || _event$target2$classL === void 0 ? void 0 : (_event$target2$classL2 = _event$target2$classL.contains) === null || _event$target2$classL2 === void 0 ? void 0 : _event$target2$classL2.call(_event$target2$classL, 'handle-1')) ? 1 : 0; // Jump to current position (move the slider select bar to the current mouse position)

      var currentPercentage = Math.ceil(startSliderPosition * 100);
      var currentValue = (0, _utils.getValueFromPercentage)(min, max, step, currentPercentage, precision);
      var curNewValue = range ? Object.assign([], value, _defineProperty({}, handleIndex, currentValue)) : currentValue;

      _this.handleOnChange((0, _utils.normalizeRangeBoundaries)(curNewValue, step, handleIndex));

      if (showTooltips) {
        _this.handleOpenHandle(handleIndex);
      } // Listener for mouse move


      var dragListener = function dragListener(e) {
        var newPosition = (e.clientX - startX) / absWidth + startSliderPosition;
        var newPercentage = Math.min(Math.max(newPosition, 0.0), 1.0) * 100;
        var newValue = (0, _utils.getValueFromPercentage)(min, max, step, newPercentage, precision);
        newValue = range ? Object.assign([], value, _defineProperty({}, handleIndex, newValue)) : newValue;

        _this.handleOnChange((0, _utils.normalizeRangeBoundaries)(newValue, step, handleIndex));

        if (showTooltips) {
          _this.handleOpenHandle(handleIndex);
        }
      };

      document.addEventListener('mousemove', dragListener);

      var cleanUpEvents = function cleanUpEvents() {
        _this.handleCloseHandle(handleIndex);

        document.removeEventListener('mousemove', dragListener);
        document.removeEventListener('mouseup', cleanUpEvents);
      };

      document.addEventListener('mouseup', cleanUpEvents);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (value) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: value
      }, function () {
        onChange(value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenHandle", function (index) {
      _this.setState(function (prevState) {
        if (!prevState.hintOpen[index]) {
          return {
            hintOpen: _objectSpread(_objectSpread({}, prevState.hintOpen), {}, _defineProperty({}, index, true))
          };
        }

        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseHandle", function (index) {
      _this.setState(function (prevState) {
        if (prevState.hintOpen[index]) {
          return {
            hintOpen: _objectSpread(_objectSpread({}, prevState.hintOpen), {}, _defineProperty({}, index, false))
          };
        }

        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderNumbers", function () {
      var _this$state2 = _this.state,
          min = _this$state2.min,
          max = _this$state2.max,
          step = _this$state2.step;
      var allNumber = (0, _range.default)(min, max, step);
      allNumber.push(max);
      var numbers = allNumber.map(function (number) {
        var percentage = (0, _utils.convertValueToPercentage)(min, max, step, number);
        return [percentage, number];
      }).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            percentage = _ref2[0],
            number = _ref2[1];

        return /*#__PURE__*/_react.default.createElement("span", {
          key: "number-value-".concat(number),
          style: {
            left: "".concat(percentage, "%")
          }
        }, number);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "numbers"
      }, numbers);
    });

    _defineProperty(_assertThisInitialized(_this), "renderHandleWithTooltip", function (handleComponent, index) {
      var _this$state3 = _this.state,
          hintOpen = _this$state3.hintOpen,
          value = _this$state3.value;
      var _this$props2 = _this.props,
          range = _this$props2.range,
          tooltipFormatter = _this$props2.tooltipFormatter;
      var hintData = tooltipFormatter(String(range ? value[index] : value));
      return /*#__PURE__*/_react.default.createElement(_sbHint.SbHint, {
        position: {
          vertical: 'top',
          horizontal: 'center'
        },
        hintData: hintData,
        disableMouse: true,
        open: hintOpen[index],
        hintClassName: "sb-seekbar-tooltip"
      }, _react.default.cloneElement(handleComponent, {
        onMouseEnter: function onMouseEnter() {
          return _this.handleOpenHandle(index);
        },
        onMouseLeave: function onMouseLeave() {
          return _this.handleCloseHandle(index);
        }
      }));
    });

    var _min = props.min,
        _max = props.max,
        _step = props.step,
        _value = props.value,
        defaultValue = props.defaultValue;
    var normalizedStep = (0, _utils.normalizeStep)(_step, _min, _max);

    var _precision = (0, _utils.decimalPlaces)(normalizedStep);

    _this.state = {
      value: _value !== null && _value !== void 0 ? _value : defaultValue,
      precision: _precision,
      hintOpen: {
        0: false,
        1: false
      },
      min: _min,
      max: _max,
      step: _step <= 0 ? 1 : _step
    };
    return _this;
  }

  _createClass(SbSeekbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node.addEventListener('mousedown', this.handleMouseDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.node.removeEventListener('mousedown', this.handleMouseDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          valueProp = _this$props3.value,
          id = _this$props3.id,
          disabled = _this$props3.disabled,
          className = _this$props3.className,
          minProp = _this$props3.min,
          maxProp = _this$props3.max,
          stepProp = _this$props3.step,
          trackContainerId = _this$props3.trackContainerId,
          trackId = _this$props3.trackId,
          showValues = _this$props3.showValues,
          showTooltips = _this$props3.showTooltips,
          range = _this$props3.range,
          tooltipFormatter = _this$props3.tooltipFormatter,
          rest = _objectWithoutProperties(_this$props3, ["value", "id", "disabled", "className", "min", "max", "step", "trackContainerId", "trackId", "showValues", "showTooltips", "range", "tooltipFormatter"]);

      var _this$state4 = this.state,
          value = _this$state4.value,
          min = _this$state4.min,
          max = _this$state4.max,
          step = _this$state4.step;
      var handle0Position = (0, _utils.convertValueToPercentage)(min, max, step, range ? value[0] : value);
      var handle1Position = range ? (0, _utils.convertValueToPercentage)(min, max, step, value[1]) : null;
      var trackWidth = range ? handle1Position - handle0Position : handle0Position;
      var trackPosition = range ? handle0Position : 0;

      var leftHandle = /*#__PURE__*/_react.default.createElement("div", {
        className: "handle handle-0",
        style: {
          left: "".concat(handle0Position, "%")
        }
      });

      var rightHandle = range ? /*#__PURE__*/_react.default.createElement("div", {
        className: "handle handle-1",
        style: {
          left: "".concat(handle1Position, "%")
        }
      }) : null;
      var calculatedTrackContainerId = trackContainerId ? trackContainerId : id ? "".concat(id, "-track-container") : null;
      var calculatedTrackId = trackId ? trackId : id ? "".concat(id, "-track") : null;
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
        id: id,
        className: (0, _classnames.default)({
          disabled: disabled
        }, 'sb-seekbar', className),
        tabIndex: "-1",
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value
      }), /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(node) {
          _this2.node = node;
        },
        id: calculatedTrackContainerId,
        className: "track-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: calculatedTrackId,
        className: "track",
        style: {
          left: "".concat(trackPosition, "%"),
          width: "".concat(trackWidth, "%")
        }
      }), showTooltips ? this.renderHandleWithTooltip(leftHandle, 0) : leftHandle, range && (showTooltips ? this.renderHandleWithTooltip(rightHandle, 1) : rightHandle)), showValues && this.renderNumbers());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var onChange = nextProps.onChange;
      var step = prevState.step,
          min = prevState.min,
          max = prevState.max,
          value = prevState.value;
      var nextStep = nextProps.step,
          nextMin = nextProps.min,
          nextMax = nextProps.max,
          nextValue = nextProps.value;

      if (nextStep > max - min) {
        console.error("The prop `step` cannot be bigger than ".concat(max - min, " in `SbSeekbar`."));
        return null;
      }

      var newState = {};
      var normalizedStep = (0, _utils.normalizeStep)(step, min, max);
      var normalizedNextStep = (0, _utils.normalizeStep)(nextStep <= 0 ? 1 : nextStep, nextMin, nextMax); // Set the new value to the state only, if it is provided

      if (!(0, _value2.isNullOrUndefined)(nextValue) && !(0, _isEqual.default)(value, nextValue)) {
        var newValue = (0, _utils.normalizeToClosestValue)({
          min: nextMin,
          max: nextMax,
          value: nextValue,
          step: normalizedNextStep,
          precision: newState.precision
        });
        newState = Object.assign(newState, {
          value: newValue,
          precision: (0, _utils.decimalPlaces)(normalizedNextStep)
        });
        onChange(newValue);
      }

      if (nextMin !== min || nextMax !== max || normalizedNextStep !== normalizedStep) {
        var _newValue = (0, _utils.normalizeToClosestValue)({
          min: nextMin,
          max: nextMax,
          value: value,
          step: normalizedNextStep,
          precision: newState.precision
        });

        newState = Object.assign(newState, {
          value: _newValue,
          step: normalizedNextStep,
          min: nextMin,
          max: nextMax,
          precision: (0, _utils.decimalPlaces)(normalizedNextStep)
        });
        onChange(_newValue);
      }

      if (!(0, _isEmpty.default)(newState)) {
        return _objectSpread({}, newState);
      }

      return null;
    }
  }]);

  return SbSeekbar;
}(_react.Component);

exports.SbSeekbar = SbSeekbar;

_defineProperty(SbSeekbar, "propTypes", {
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  onChange: _propTypes.default.func,
  range: _propTypes.default.bool,
  showTooltips: _propTypes.default.bool,
  showValues: _propTypes.default.bool,
  step: function step(props, propName, componentName) {
    if (typeof props[propName] !== 'number') {
      return new Error("The prop `".concat(propName, "` must be a number in `").concat(componentName, "`."));
    }

    if (props[propName] <= 0) {
      return new Error("The prop `".concat(propName, "` must be bigger then 0 in `").concat(componentName, "`."));
    }

    return null;
  },
  tooltipFormatter: _propTypes.default.func,
  trackContainerId: _propTypes.default.string,
  trackId: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)])
});

_defineProperty(SbSeekbar, "defaultProps", {
  className: null,
  defaultValue: 0,
  disabled: false,
  id: null,
  max: 10,
  min: 0,
  onChange: function onChange() {},
  range: false,
  showTooltips: false,
  showValues: false,
  step: 1,
  tooltipFormatter: function tooltipFormatter(value) {
    return value;
  },
  trackContainerId: null,
  trackId: null,
  value: null
});
//# sourceMappingURL=sb-seekbar.js.map